import { Component, OnInit } from '@angular/core';
// import { Idle } from 'idlejs/dist';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  isWhittier: boolean;
  currentUrl: string;
  isNavbarCollapsed: boolean;

  constructor(public authService: AuthService) { this.isNavbarCollapsed = true; }

  ngOnInit() {
    // first remove the slashes
    this.currentUrl = window.location.href.replace(/\//g, '');
    // console.log(this.currentUrl);

    // create the new regex
    const match: RegExp = /\b(\w*whittier\w*)\b/;
    this.isWhittier = match.test(this.currentUrl);
    // console.log(this.isWhittier);

    // call idlejs to autologout with predefined events on `document`
    // const idle = new Idle()
    // .whenNotInteractive()
    // .within(12)
    // .do(() => this.authService.logout() )
    // .start();
  }

  logout() {
    this.authService.logout();
  }

}
